// ─────────────────────────────────────────────────────────────────────────────
// app/components/Providers.tsx
// Yazar: Bilge
//
// Tüm uygulamayı saran "sarmalayıcı" (wrapper) bileşeni.
// app/layout.tsx içinde <Providers> olarak kullanılır; bu sayede
// uygulama içindeki her sayfa ve bileşen Redux store'a erişebilir.
//
// Ne içeriyor?
//   - Redux <Provider>: useSelector ve useDispatch hook'larının çalışması için gerekli
//   - <TooltipProvider>: ShadCN tooltip bileşenlerinin düzgün çalışması için gerekli
//
// "use client" direktifi: Next.js'te sunucu bileşenlerini (server component)
// Redux Provider gibi tarayıcıya özgü yapılarla sarmak için gereklidir.
// ─────────────────────────────────────────────────────────────────────────────

"use client";

import { Provider } from "react-redux";
import { store } from "@/app/lib/store";
import { TooltipProvider } from "@/app/components/shadcn/tooltip";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    // Redux store'u tüm alt bileşenlere sağlar
    <Provider store={store}>
      {/* ShadCN Tooltip bileşenlerinin context'i — tüm uygulamada tooltip kullanımı için */}
      <TooltipProvider>{children}</TooltipProvider>
    </Provider>
  );
}